import { AuthInterceptor } from './auth.interceptor';

export function authInterceptorFactory() {
  return new AuthInterceptor();
}
